import { CONSTANTS } from '../_data/lookups.js';
import { extractResourceTypeHandleFromRole } from './workflowExtraction.js';
export function getSingleNonErrorOutputRoleName(toolStep) {
    const decisionRoleNames = toolStep.roleBindingSpec.outputBindings.filter((roleName) => roleName !== CONSTANTS.Cosmos.RoleNames.ErrorOutput);
    if (decisionRoleNames.length !== 1) {
        throw new Error(`Expected exactly one non-error output role for tool step '${toolStep.stepKey}'; got ${decisionRoleNames.length}`);
    }
    const decisionRoleName = decisionRoleNames[0];
    if (!decisionRoleName) {
        throw new Error(`Expected non-error output role name for tool step '${toolStep.stepKey}'`);
    }
    return decisionRoleName;
}
export function getSingleNonErrorBooleanOutputRoleName(whenToolStep, toolMap) {
    const tool = toolMap.get(whenToolStep.toolHandle);
    if (!tool) {
        throw new Error(`Tool '${whenToolStep.toolHandle}' not found in toolMap`);
    }
    const decisionRoleName = getSingleNonErrorOutputRoleName(whenToolStep);
    const decisionRole = tool.roleSpec.outputRoleByName[decisionRoleName];
    if (!decisionRole) {
        throw new Error(`Expected roleSpec for output role '${decisionRoleName}' on tool '${tool.handle}'`);
    }
    const decisionTypeHandle = extractResourceTypeHandleFromRole(decisionRole);
    if (decisionTypeHandle !== CONSTANTS.Handles.ResourceTypes.TYPE_Boolean) {
        throw new Error(`Expected boolean output role '${decisionRoleName}' on tool '${tool.handle}', got '${decisionTypeHandle ?? 'non-resource-backed'}'`);
    }
    return decisionRoleName;
}
export function readMaterializedBooleanDecision(workflowState, whenToolStep, toolMap) {
    const decisionRoleName = getSingleNonErrorBooleanOutputRoleName(whenToolStep, toolMap);
    const stepKey = whenToolStep.stepKey;
    const entry = workflowState[stepKey]?.[decisionRoleName];
    if (!entry || entry.workflowStateEntryKind !== CONSTANTS.Enums.WorkflowStateEntryKind.materializedResource) {
        throw new Error(`Expected materialized decision for tool step '${stepKey}' and role '${decisionRoleName}' not found in workflow state`);
    }
    const decision = entry.projection;
    if (typeof decision !== 'boolean') {
        throw new Error(`Expected boolean value for Decision at (stepKey='${stepKey}', roleName='${decisionRoleName}')`);
    }
    return decision;
}
